import CircleCheck from "lucide-react/dist/esm/icons/circle-check";
import CircleX from "lucide-react/dist/esm/icons/circle-x";
import Clock from "lucide-react/dist/esm/icons/clock";
import CircleSlash from "lucide-react/dist/esm/icons/circle-slash";
import {
  TASK_STATE_COMPLETED,
  TASK_STATE_FAILED,
  TASK_STATE_PENDING,
  TASK_STATE_RUNNING,
} from "../../shared/api";

// GitLab-style "running": a static ring with its right half filled. A spinner that
// doesn't spin reads as frozen, and a spinning one is noise in a long list.
function RunningIcon({ size, style }: { size: number; style: React.CSSProperties }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="var(--mantine-color-blue-6)" strokeWidth={2} style={style} aria-label="В процессе" role="img">
      <circle cx="12" cy="12" r="10" />
      <path d="M12 6a6 6 0 0 1 0 12z" fill="var(--mantine-color-blue-6)" stroke="none" />
    </svg>
  );
}

// Theme-aware task-status icon. Uses lucide (SVG, currentColor) + Mantine color
// tokens so it renders correctly in both light and dark schemes — unlike the
// old raster PNGs. All icons are static (no animation).
export function StatusIcon({ state, size = 20 }: { state: string; size?: number }) {
  const style = { flexShrink: 0 } as const;
  switch (state) {
    case TASK_STATE_COMPLETED:
      return <CircleCheck size={size} color="var(--mantine-color-green-6)" style={style} aria-label="Успешно" />;
    case TASK_STATE_FAILED:
      return <CircleX size={size} color="var(--mantine-color-red-6)" style={style} aria-label="Ошибка" />;
    case "cancelled":
      return <CircleSlash size={size} color="var(--mantine-color-dimmed)" style={style} aria-label="Отменено" />;
    case TASK_STATE_PENDING:
      return <Clock size={size} color="var(--mantine-color-dimmed)" style={style} aria-label="Ожидание" />;
    case TASK_STATE_RUNNING:
    default:
      return <RunningIcon size={size} style={style} />;
  }
}
